import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import PropTypes from 'prop-types';

import PublicConsultationsListingBody from './PublicConsultationsListingBody';
import PublicConsultationsListingData from './PublicConsultationsListingData';

const Edit = (props) => {
  const { data, block, selected } = props;

  return (
    <>
      <PublicConsultationsListingBody data={data} isEditMode />
      <SidebarPortal selected={selected}>
        <PublicConsultationsListingData
          key={block}
          {...props}
          data={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};

Edit.propTypes = {
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.bool,
};

export default Edit;
